/***
 *
 *   CATEGORY SETTINGS LAYOUT STYLES
 *   Reference CategorySettingsLayout / project category settings page chrome.
 *
 **********/

const Style = {
    shell: 'flex min-h-0 flex-1 flex-col gap-6',
    header: 'flex items-center gap-3',
    accent: 'h-8 w-1 shrink-0 rounded-full',
    title: 'truncate text-lg font-semibold text-text-primary',
    meta: 'text-sm text-text-secondary',
    tabs: 'w-full shrink-0 justify-start',
    body: 'min-w-0 flex-1',
};

export default Style;
